import * as React from "react";

import Blog1Image from "./../images/blogPreview/blog-preview-1.jpeg";
import Blog2Image from "./../images/blogPreview/blog-preview-2.jpeg";
import Blog3Image from "./../images/blogPreview/blog-preview-3.png";

const blogReferences = [
  {
    tag: "CROSS-CHANNEL ENGAGEMENT",
    img: Blog1Image,
    title: "Targeted email marketing for ecommerce",
    description: "Today, there are so many brands doing ads online and its hard to differenciate and standout from competitors. Customers today are expect a personalized buying experience. Targeted email marketing is one of...",
    link: "https://growlytics-blogs.webflow.io/blog/using-targeted-email-marketing-for-ecommerce",
  },
  {
    tag: "MARKETING-AUTOMATION",
    img: Blog2Image,
    title: "Optimize your browse abandonment followups",
    description: "While abandoned cart followups are important, just imagine if a customers clicks your ad on facebook and comes to the websites, browses few products and leaves without making any purchase. In this scenario...",
    link: "https://growlytics-blogs.webflow.io/blog/how-to-implement-cart-abandonment-solutions-for-maximum-revenue",
  },
  {
    tag: "CROSS-CHANNEL ENGAGEMENT",
    img: Blog3Image,
    title: "SMS Marketing Mistakes to Avoid",
    description: "SMS marketing is becoming extremely important for businesses to reach their customers than other channels such as email or WhatsApp. With proper SMS marketing practices, businesses can acheive increased sales...",
    link: "https://growlytics-blogs.webflow.io/blog/sms-marketing-mistakes-to-avoid",
  },
];

export default function FooterSection() {
  return (
    <div class="relative bg-gray-50 px-4 pt-16 pb-20 sm:px-6 lg:px-8 lg:pt-24 lg:pb-28">
      <div class="absolute inset-0">
        <div class="h-1/3 sm:h-2/3"></div>
      </div>
      <div class="relative mx-auto max-w-7xl">
        {/* Header */}
        <div class="text-center">
          <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">From the blog</h2>
          <p class="mx-auto mt-3 max-w-2xl text-xl text-gray-500 sm:mt-4">All you need to know about marketing automation, customer engagement and Growlytics Platform is right here. Read on to learn from the experts.</p>
        </div>

        <div class="mx-auto mt-12 grid max-w-lg gap-5 lg:max-w-none lg:grid-cols-3">
          {blogReferences.map((blog) => {
            return (
              <div class="flex flex-col overflow-hidden rounded-lg border">
                <div class="flex-shrink-0">
                  <img class="h-54 w-full object-cover" src={blog.img} alt="" />
                </div>
                <div class="flex flex-1 flex-col justify-between bg-white p-6">
                  <div class="flex-1">
                    <p class="text-sm font-medium text-secondary-700">
                      <a href="#" class="hover:underline">
                        {blog.tag}
                      </a>
                    </p>
                    <a href="#" class="mt-2 block">
                      <p class="text-xl font-semibold text-gray-900">{blog.title}</p>
                      <p class="mt-3 text-base text-gray-500">{blog.description}</p>
                    </a>
                  </div>
                  <a href={blog.link}>
                    <div class="mt-4 flex items-center text-primary-600 font-semibold">
                      Read More &nbsp; <i class="fa-solid fa-arrow-right-long mt-1"></i>
                    </div>
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
